export const convertDatePtBr = (date, yearFormat = "AAAA") => {
  if (date) {
    const formattedDate = (
      new Date(date.replace(/Z/g, "")).toLocaleString("pt-br") || ""
    ).substring(0, 10);

    if (yearFormat === "AA") {
      const parts = formattedDate.split("/");

      const shortYear = parts[2].substring(2);
      return `${parts[0]}/${parts[1]}/${shortYear}`;
    } else {
      return formattedDate;
    }
  }
};
